import Configs from 'utils/Configs';

const HOST_PROD_URL = {
  VN1: 'https://aseller-1.xgit.io.vn/',
  VN1_CF: 'https://aseller-1-cf.xgit.io.vn/',
  VN2: 'https://aseller-2.xgit.io.vn/',
  VN2_CF: 'https://aseller-2-cf.xgit.io.vn/',
  SG: 'https://aseller-sg.xgit.io.vn/',
  SG_CF: 'https://aseller-sg-cf.xgit.io.vn/',
  ASELLER: 'https://api.aseller.vn/',
  ASELLER_OLD: 'https://api.quanlybanhangaseller.com/'
};

const HOST = {
  local: 'http://192.168.1.188:8804/',
  // local: 'http://192.168.32.189:8804/',
  dev: 'http://api-test.quanlybanhangaseller.com/',
  beta: 'https://aseller.xgit.io.vn/',
  prod: HOST_PROD_URL.VN1
};

const CDN = {
  local: 'http://192.168.1.188:8804/cdn/',
  dev: 'https://aseller-cdn.xgit.io.vn/',
  prod: 'https://aseller-cdn.xgit.io.vn/',
  beta: 'https://aseller-cdn.xgit.io.vn/'
};

const UPLOAD = {
  local: 'http://192.168.1.188:3000/',
  beta: 'https://beta.quanlybanhangaseller.com/',
  dev: 'https://test.quanlybanhangaseller.com/',
  prod: 'https://quanlybanhangaseller.com/'
};

export default {
  API: HOST[Configs.mode],
  VN1_HOSTS: [HOST_PROD_URL.VN1_CF, HOST_PROD_URL.ASELLER, HOST_PROD_URL.ASELLER_OLD, HOST_PROD_URL.VN1],
  VN2_HOSTS: [HOST_PROD_URL.VN2_CF, HOST_PROD_URL.VN2],
  SG_HOSTS: [HOST_PROD_URL.SG_CF, HOST_PROD_URL.SG],
  IMAGES: CDN[Configs.mode] + 'images/',
  UPLOAD: UPLOAD[Configs.mode],
  CDN: CDN[Configs.mode]
};
